<template>

  <div class="floating-label time-picker" :class="{ open: isOpen }">
    <input v-model="human" placeholder=" " type="text" class="with-icon-right" :class="{ invalid: false }" ref="search" @focus="toggleOpenSelect(true)" @blur="handleClickOutside" @keyup.enter="confirm" />
    <i class="fa fa-fw right" :class="{ 'fa-chevron-up': isOpen, 'fa-chevron-down': !isOpen }" @click.stop="toggleOpenSelect"></i>
    <label>{{label}}</label>

    <!-- <div class="results-picker-box2"></div> -->
    <ul class="results-picker-box" :style="ulStyle">
      <li v-if="results.length === 0">{{ 'StartDigitation' | lang }}</li>
      <li @click="select('CP')">{{ 'CurrentPosition' | lang }}</li>
      <li v-for="p in results" :key="p.id" @click="select(p)" :class="{ selected: p === place }">{{p.description}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PlacePicker',
  props: {
    value: {
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false
    },
    label: {
      type: String,
      required: false,
      default: 'Place'
    },
    coords: {
      type: Boolean,
      required: false,
      default: false
    } /* ,
    defaultCurrentPos: {
      type: Boolean,
      required: false,
      default: false
    } */
  },
  data () {
    return {
      open: false,
      interval: null,
      sizeAndPosition: {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      },
      place: null,
      human: '',
      results: [],
      sessionToken: null
    }
  },
  computed: {
    isOpen () {
      return this.open
    },
    ulStyle () {
      return `left:${this.sizeAndPosition.left}px;top:${this.sizeAndPosition.top}px;width:${this.sizeAndPosition.width}px` // ;max-height:${this.sizeAndPosition.maxHeight}px`
    }
  },
  methods: {
    async select (place) {
      if (place === 'CP') {
        place = { is_cp: true, description: this.dictValue('CurrentPosition') }
        /* let result = await this.getCurrentPosition()
        console.log(result)
        if (result.coords) {
          place = { latlng: { lat: result.coords.latitude, lng: result.coords.longitude }, description: this.dictValue('CurrentPosition') }
        } else if (result.code === 1) {

        } */
      } else {
        /* let result = await new Promise((resolve, reject) => {
          var geocoder = new window.google.maps.Geocoder()
          geocoder.geocode({ 'address': place.place_id }, function(results, status) {
            if (status == window.google.maps.GeocoderStatus.OK) {
                resolve(results[0].geometry.location)
            } else {
                alert("Can't find address: " + status)
                reject("Can't find address: " + status)
            }
          })
        }) */
        if (this.coords) {
          let result = await new Promise((resolve, reject) => {
            try {
              let placeServices = new window.google.maps.places.PlacesService(document.createElement('div'))
              placeServices.getDetails(
                { reference: place.reference },
                (details, status) => {
                  if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                    resolve(details.geometry.location)
                  } else {
                    reject(details, status)
                  }
                }
              )
            } catch (e) {
              console.error(e)
              reject(e)
            }
          })
          place.latlng = { lat: result.lat(), lng: result.lng() }
        }
      }
      this.human = place.description
      this.closeOut(place)
    },
    searchPlace () {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.results = []
        this.sessionToken = this.sessionToken || new window.google.maps.places.AutocompleteSessionToken()
        if (this.human) {
          var autocompleteService = new window.google.maps.places.AutocompleteService(this.$el.querySelector('.results-picker-box2'))
          autocompleteService.getPlacePredictions({
            input: this.human,
            sessionToken: this.sessionToken
          },
          (predictions, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
              this.results = predictions
            }
          })
        }
        /* const request = {
          query: this.human,
          fields: ["name", "id"]
        }
        let service = new window.google.maps.places.PlacesService(this.$el.querySelector('.results-picker-box2'))
        service.textSearch(request, (results, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            console.log(results)
            this.results = results
          } else {
            console.log(results, status)
          }
        }) */
        // this.$http.get(`https://maps.googleapis.com/maps/api/place/findplacefromtext/json?input=${encodeURIComponent(this.human)}&inputtype=textquery&fields=name,id&key=${this.gKey}`, this.completeHttpParams({})).then(response => response.body)
      }, 500)
    },
    aggiornaComponenti () {
      if (this.value) {
        this.place = this.value
        this.human = this.value.description
        // console.log('aggiornaComponenti', this.value, this.open)
      } else {
        // do nothing or reset human?
      }
    },
    confirm () {
      this.closeOut(this.results.length > 0 ? this.results[0] : null)
    },
    cancel () {
      this.closeOut()
    },
    toggleOpenSelect (force) {
      if (force === true) {
        this.open = true
      } else if (force === false) {
        this.open = false
      } else {
        this.open = !this.open
      }
      this.aggiornaComponenti()
      if (this.open && this.value /* && this.value.is_cp */ ) {
        this.results.splice(0, this.results.length)
        this.human = ''
      }
    },
    closeOut (value) {
      if (value) {
        this.$emit('input', value)
      } // else {
        this.aggiornaComponenti()
      // }
      this.open = false
    },
    handleClickOutside (e) {
      if (!this.$el.contains(e.target)) {
        this.closeOut()
      }
    },
    fixSizeAndPosition () {
      if (!this.$refs.search) {
        console.warn('manca search ref')
        return
      }
      var rect = this.$refs.search.getBoundingClientRect()
      var upside = false
      var top = rect.top + rect.height
      /* var windowHeight = window.innerHeight
                      || document.documentElement.clientHeight
                      || document.body.clientHeight
      var windowWidth = window.innerWidth
                      || document.documentElement.clientWidth
                      || document.body.clientWidth */
      // var maxHeight = windowHeight - top - 5
      var left = rect.left

      // console.log(rect)

      //console.log(this.$refs.secondary)
      /* if (this.$refs.secondary) {
        var el = this.$refs.secondary
        if (el.scrollHeight > windowHeight - top - 5 && windowHeight - top < top) {
          top = Math.max(5, rect.top - el.scrollHeight + 2)
          // maxHeight = rect.top - top - 2
          upside = true
        }
        var onRight = (windowWidth - 1) - (left + el.scrollWidth)
        if (onRight < 0) {
          left += onRight 
        }
      } */

      this.sizeAndPosition.width = rect.width
      this.sizeAndPosition.left = left
      this.sizeAndPosition.top = top + 2
      // this.sizeAndPosition.maxHeight = maxHeight
      this.sizeAndPosition.upside = upside
    },
  },
  mounted () {
    this.aggiornaComponenti()
    this.interval = setInterval(this.fixSizeAndPosition, 150)
    /* if (this.defaultCurrentPos) {
      this.select('CP')
    } */
  },
  beforeDestroy () {
    clearInterval(this.interval)
    clearTimeout(this.timeout)
  },
  destroyed () {
    document.removeEventListener("keyup", this.handleClickOutside)
    document.removeEventListener("mousedown", this.handleClickOutside)
  },
  watch: {
    isOpen () {
      if (this.isOpen) {
        document.addEventListener("keyup", this.handleClickOutside)
        document.addEventListener("mousedown", this.handleClickOutside)
        this.$nextTick().then(() => {
          this.$refs.search.focus()
        })
      } else {
        document.removeEventListener("keyup", this.handleClickOutside)
        document.removeEventListener("mousedown", this.handleClickOutside)
      }
    },
    disabled (curr) {
      if (curr) {
        this.closeOut()
      }
    },
    value (newV) {
      // value changed
      this.place = newV
      this.aggiornaComponenti()
    },
    human () {
      // this.aggiornaComponenti()
      if (this.place && this.place.description !== this.human || !this.place) {
        // console.log('human changed')
        this.searchPlace()
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';

.time-picker {


  &.open {
    .results-picker-box {
      opacity: 1;
      display: flex;
    }
  }
  .results-picker-box {
    background: var(--white);
    border: 1px solid --gray;
    position: fixed;
    z-index: 10000;
    opacity: 0.1;
    display: none;
    flex-direction: column;
    align-items: stretch;
    min-width: 8rem;

    & > div {
      display: flex;
      flex-direction: row;
      max-height: 10rem;

      & > div {
        flex: 1 1 33%;
        border-left: 1px solid gray;
        
        &:first-child {
          border-left: none;
        }
      }
    }

    .buttons {
      button {
        flex: 1 1 50%;
        margin: 0;

        &:first-child {
          margin-right: 1px;
        }
      }
    }
  }

  ul {
    list-style: none;

    li {
      width: 100%;
      height: 2rem;
      line-height: 2rem;
      text-align: left;
      padding: 0 1rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &.selected {
        background: var(--primarytransparent);
      }
    }
  }
}
</style>
